import { Box, Table, TableBody, TableRow, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import ItemUl from '../Elements/ItemUl'
import LoadingSpinner from '../../../../../../Loading/LoadingSpinner'
import TitleClass from '../Elements/TitleClass'

const ByStudent = ({ isLoading, view = 'current' }) => {
  const field = view === 'current' ? 'byStudent' : 'byStudentHistory'
  const byStudent = useSelector((state) => state?.analytics?.analyticsCurriculum?.[field] || [])

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <Box>
          {byStudent.length === 0 && (
            <Box className='flex justify-center items-center h-40'>
              <Typography variant='h6' color='textSecondary'>
                No data available
              </Typography>
            </Box>
          )}
          {byStudent.map((student) => (
            <Box key={student.classId}>
              <Box className='bg-primary text-primary-foreground grid grid-cols-3 sticky top-10 z-1'>
                <TitleClass classData={student} />
              </Box>
              <Table>
                <TableBody>
                  {student.unitOfLearning.map((s) => (
                    <TableRow key={s.unitOfLearningId}>
                      <ItemUl ul={s} lcs={s.lcs} result={s.result} />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          ))}
        </Box>
      )}
    </>
  )
}

export default ByStudent
